import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import IndustryProfile from '../views/IndustryProfile'
import IndustryTrends from '../views/IndustryTrends'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Home',
    redirect: '/home',
    meta:{
      title:'惠州市天宇信息技术有限公司'
    }
  },
  {
    path: '/home',
    name: 'Home',
    component: Home,
    meta:{
      title:'惠州市天宇信息技术有限公司'
    }
  },
  {
    path: '/industryprofile',
    name: 'IndustryProfile',
    component: IndustryProfile,
    meta:{
      title:'公司介绍'
    }
  },
  {
    path: '/industrytrends',
    name: 'IndustryTrends',
    component: IndustryTrends,
    meta:{
      title:'企业文化'
    }
  },
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
